import psfaConfig from './psfa';
import type { Page, Question } from '../types';

function getQuestionsForPage(page: Page): Question[] {
  if (page.pageType === 'question' || page.pageType === 'list') {
    return page.questions ?? [];
  }
  return [];
}

describe('PSFA autofillMath config', () => {
  it('references source fields that exist on the same page', () => {
    const errors: string[] = [];

    for (const section of psfaConfig.sections) {
      for (const subsection of section.subsections) {
        for (const page of subsection.pages) {
          const questions = getQuestionsForPage(page);
          const questionNames = new Set(
            questions.map((question) => String(question.name)).filter(Boolean)
          );

          for (const question of questions) {
            const autofillMath = question.autofillMath;
            if (!autofillMath) continue;

            for (const [alias, sourceFieldName] of Object.entries(autofillMath.fields)) {
              if (!questionNames.has(sourceFieldName)) {
                errors.push(
                  `${subsection.slug}/${page.name}/${question.name}: ${alias} -> ${sourceFieldName}`
                );
              }
            }
          }
        }
      }
    }

    expect(errors).toEqual([]);
  });

  it('does not include auto-calculated ongoing investigation questions', () => {
    const questionNames: string[] = [];

    for (const section of psfaConfig.sections) {
      for (const subsection of section.subsections) {
        for (const page of subsection.pages) {
          questionNames.push(
            ...getQuestionsForPage(page)
              .map((question) => String(question.name))
              .filter(Boolean)
          );
        }
      }
    }

    expect(questionNames).not.toContain('fraud_investigations_ongoing');
    expect(questionNames).not.toContain('bribery_investigations_ongoing');
  });

  it('configures suspected whistleblowing count against fraud and bribery allegations', () => {
    const otherFraudSection = psfaConfig.sections.find((section) => section.slug === 'other-fraud');
    const whistleblowingSubsection = otherFraudSection?.subsections.find(
      (subsection) => subsection.slug === 'suspected-wb'
    );
    const whistleblowingPage = whistleblowingSubsection?.pages.find(
      (page) => page.name === 'suspected-whistleblowing'
    );
    const totalQuestion = getQuestionsForPage(whistleblowingPage as Page).find(
      (question) => question.name === 'total_allegations'
    );

    expect(totalQuestion?.title).toBe(
      'How many of the {x} suspected fraud/bribery instances in this return are a result of whistleblowing?'
    );
    expect(totalQuestion?.answerSumReferences).toEqual([
      {
        token: 'x',
        answerKeys: ['fraud_allegations', 'bribery_allegations'],
        nilReturnOverrides: {
          fraud_allegations: {
            field: 'fraud_allegations_declare',
            value: 'No',
          },
          bribery_allegations: {
            field: 'bribery_allegations_declare',
            value: 'No',
          },
        },
      },
    ]);
    expect(totalQuestion?.customValidation).toMatchObject({
      sumLessThanOrEqualToAnswers: ['fraud_allegations', 'bribery_allegations'],
      sumLessThanOrEqualToAnswersNilReturnOverrides: {
        fraud_allegations: {
          field: 'fraud_allegations_declare',
          value: 'No',
        },
        bribery_allegations: {
          field: 'bribery_allegations_declare',
          value: 'No',
        },
      },
    });
  });
});
